import FormInput, { IFormInputProps } from './FormInput'

export default FormInput
export type { IFormInputProps }

